import { css } from 'styled-components';

export const DropdownContainer = css`
  width: 100%;
  margin-bottom: 20px;
  padding-right: 20px;
`;

export const DropdownIcon = css`
  cursor: pointer;
`;

export const DropdownTitle = css`
`;

export const DropdownContentWrapper = css`
  top: 40px;
`;

export const DropdownContentHeader = css`
`;
